module.exports = __webpack_public_path__ + "static/media/ilus-test.9e4d476e.jpeg";